module.exports = __webpack_public_path__ + "static/img/card_icon_cjsz@2x.d4c53e7c.png";